import React from 'react';
import { FJ710 } from '../../../services/c209Api';

interface Tab3Props {
  formData: Partial<FJ710>;
  names: Record<string, string>;
  isEditing: boolean;
  getField: (key: keyof FJ710) => FJ710[keyof FJ710];
  setField: (key: keyof FJ710, value: FJ710[keyof FJ710]) => void;
  resolveSingleName: (nameKey: string, type: string, code: string) => void;
}

/** Tab 3: 備註 (Page4 in spec) */
const Tab3Remarks: React.FC<Tab3Props> = React.memo(({
  formData, names, isEditing, getField, setField, resolveSingleName,
}) => (
  <div className="tab-content-section">
    <h3 className="section-title">備註</h3>

    {/* Remark code (BR-V09, BR-V13, BR-F13) */}
    <div className="form-grid" style={{ gridTemplateColumns: 'auto 1fr' }}>
      <label>備註代號</label>
      <div className="lookup-field">
        <input
          type="text"
          value={getField('fj710_231') as string || ''}
          onChange={e => setField('fj710_231', e.target.value)}
          onBlur={() => resolveSingleName('remarkCode', 'remark', getField('fj710_231') as string)}
          disabled={!isEditing}
          style={{ width: 80 }}
        />
        <span className="lookup-name">{names.remarkCode || ''}</span>
      </div>
    </div>

    {/* Remark content (memo) */}
    <div className="memo-group" style={{ marginTop: 12 }}>
      <label>備註內容</label>
      <textarea
        value={getField('fj710_232') as string || ''}
        onChange={e => setField('fj710_232', e.target.value)}
        disabled={!isEditing}
        readOnly={!isEditing}
        rows={8}
        style={{ width: '100%' }}
      />
    </div>
  </div>
));

Tab3Remarks.displayName = 'Tab3Remarks';

export default Tab3Remarks;
